import React, { Component } from "react";
import {
    message,
    PageHeader,
    Spin,
    Row,
    Col,
    Select,
} from "antd";
import {
    Form,
    SelectItem,
    FormItem,
    InputNumberItem,
    DatePickerItem,
    ButtonItem,
    InputItem,
    NotificacionPolizas,
    ErrorItem
} from "../../../../Components/Items";
import GeneralFormLayout from "../../../../Components/GeneralFormLayout";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import SelectProveedoresItem from "../../../../Components/SelectProveedoresItem";

const { Option } = Select

moment.locale("es");

class AgregarAbonoProveedor extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        datosFactura: undefined,
        objetoBancos: null,
        todasMonedas: [],
        objetoMonedas: null,
        todasProyectos: [],
        objetoProyectos: null,
        todasFormasDePago: [],
        objetoFormasDePago: null,
    };
    componentDidMount() {
        this.consultarTodo();
    }
    async consultarTodo() {
        this.setState({ loading: true });
        await axios
            .post(
                "abonosProveedores/selectDatosParaAbono",
                { empresaId: this.props.empresaId },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        todasMonedas: res.data.monedas,
                        todasProyectos: res.data.proyectos,
                        todasFormasDePago: res.data.formasDePago,
                        todasBancos: res.data.bancos,
                        objetoMonedas: res.data.monedas.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre + " - " + value.abreviacion}
                                </Option>
                            );
                        }),
                        objetoProyectos: res.data.proyectos.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                        objetoFormasDePago: res.data.formasDePago.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value?.c_FormaPago + ' - ' + value.descripcion}
                                </Option>
                            );
                        }),
                        objetoBancos: res.data.bancos.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre + ' - ' + value.banco}
                                </Option>
                            );
                        }),
                    });
                } else {
                    message.error(res.data.message || "Hubo un error al consultar los datos para el abono");
                }
            });
        this.setState({ loading: false });
    }
    onFinishFailed(e) {
        ErrorItem(e);
    }
    onFinish(values) {
        this.setState({ loading: true });
        axios
            .post(
                "abonosProveedores/agregarAbonoProveedor",
                {
                    ...values,
                    empresaId: this.props.empresaId,
                },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success(
                        "Se ha registrado un abono al proveedor"
                    );
                    NotificacionPolizas(res.data.polizasId)
                    this.formRef.current.resetFields();
                    this.atras(res.data.codigo);
                } else {
                    message.error(res.data.message || "Hubo un error y no se efectuo el abono");
                }
            });
    }
    atras() {
        this.props.history.goBack();
    }
    render() {
        return (
            <>
                <PageHeader
                    onBack={this.atras.bind(this)}
                    title="Agregar Abono Proveedor"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                />
                <div className="card-background">
                    <Spin spinning={this.state.loading}>
                        <Form
                            ref={this.formRef}
                            name="agregarAbonoProveedor"
                            layout
                            onFinish={this.onFinish.bind(this)}
                            onFinishFailed={this.onFinishFailed}
                        >
                            <GeneralFormLayout
                                cards={[
                                    {
                                        title: "Datos del Pago",
                                        sm: 24,
                                        lg: 24,
                                        xl: 12,
                                        content: (
                                            <Row gutter={[16, 0]}>
                                                <Col span={24}>
                                                    <FormItem
                                                        label="Fecha de Pago"
                                                        name="fechaPago"
                                                        required
                                                        margin
                                                        initialValue={moment()}
                                                        labelCol={{ span: 7 }}
                                                        wrapperCol={{ span: 17 }}

                                                    >
                                                        <DatePickerItem
                                                            placeholder="Fecha de Pago"
                                                            allowClear={false}
                                                        />
                                                    </FormItem>
                                                    <FormItem
                                                        label="Proveedor"
                                                        name="proveedorId"
                                                        required
                                                        margin
                                                        labelCol={{ span: 7 }}
                                                        wrapperCol={{ span: 15 }}
                                                    >
                                                        <SelectProveedoresItem
                                                            empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                                            headersToken={this.props.headersToken}
                                                            sinBorde
                                                            autoFocus
                                                            dropdownMatchSelectWidth={600}
                                                            width="100%"
                                                            placeholder="Proveedor"
                                                        />
                                                    </FormItem>
                                                    <FormItem
                                                        label="Proyecto"
                                                        name="proyectoId"
                                                        margin
                                                        required
                                                        labelCol={{ span: 7 }}
                                                        wrapperCol={{ span: 15 }}
                                                    >
                                                        <SelectItem placeholder="Proyecto">
                                                            {this.state.objetoProyectos}
                                                        </SelectItem>
                                                    </FormItem>
                                                    <FormItem
                                                        name="referencia"
                                                        label="Referencia"
                                                        pattern
                                                        margin
                                                        labelCol={{ span: 7 }}
                                                        wrapperCol={{ span: 15 }}
                                                    >
                                                        <InputItem placeholder="Referencia" />
                                                    </FormItem>
                                                </Col>
                                            </Row>
                                        ),
                                    },
                                    {
                                        title: "Detalles del Abono",
                                        sm: 24,
                                        lg: 24,
                                        xl: 12,
                                        content: (
                                            <Row gutter={[16, 0]}>
                                                <Col span={24}>
                                                    <FormItem
                                                        required
                                                        number
                                                        label="Monto"
                                                        name="monto"
                                                        type="number"
                                                        margin
                                                        labelCol={{ span: 7 }}
                                                        wrapperCol={{ span: 15 }}
                                                    >
                                                        <InputNumberItem dinero placeholder="Monto" />
                                                    </FormItem>
                                                    <FormItem
                                                        label="Banco Destino"
                                                        name="bancoId"
                                                        required
                                                        margin
                                                        labelCol={{ span: 7 }}
                                                        wrapperCol={{ span: 15 }}
                                                    >
                                                        <SelectItem placeholder="Banco Destino">
                                                            {this.state.objetoBancos}
                                                        </SelectItem>
                                                    </FormItem>
                                                    <FormItem
                                                        name="formaDePagoId"
                                                        label="Forma de Pago"
                                                        margin
                                                        required
                                                        labelCol={{ span: 7 }}
                                                        wrapperCol={{ span: 15 }}
                                                    >
                                                        <SelectItem placeholder="Forma de Pago">
                                                            {this.state.objetoFormasDePago}
                                                        </SelectItem>
                                                    </FormItem>
                                                    <FormItem
                                                        required
                                                        margin
                                                        name="monedaId"
                                                        label="Moneda"
                                                        initialValue="60c7e4396465ad440c41c15a"
                                                        labelCol={{ span: 7 }}
                                                        wrapperCol={{ span: 15 }}
                                                    >
                                                        <SelectItem onChange={(value) => {
                                                            if (value === '60c7e4396465ad440c41c15a') {
                                                                this.formRef.current.setFieldsValue({ tipoDeCambio: 1 })
                                                            }
                                                        }} placeholder="Moneda">
                                                            {this.state.objetoMonedas}
                                                        </SelectItem>
                                                    </FormItem>
                                                    <FormItem noStyle shouldUpdate={(prev, curr) => prev.monedaId !== curr.monedaId}>
                                                        {({ getFieldValue }) => {

                                                            const monedaId = getFieldValue('monedaId')

                                                            return (
                                                                <FormItem
                                                                    required
                                                                    number
                                                                    margin
                                                                    label="T. Cambio"
                                                                    name="tipoDeCambio"
                                                                    type="number"
                                                                    initialValue={1}
                                                                    labelCol={{ span: 7 }}
                                                                    wrapperCol={{ span: 15 }}
                                                                >
                                                                    <InputNumberItem
                                                                        disabled={monedaId === '60c7e4396465ad440c41c15a'}
                                                                        dinero
                                                                        placeholder="T. Cambio"
                                                                    />
                                                                </FormItem>
                                                            )
                                                        }}
                                                    </FormItem>
                                                </Col>
                                            </Row>
                                        ),
                                    },
                                ]}
                                actionButtons={
                                    <ButtonItem
                                        type="primary"
                                        htmlType="submit"
                                        cyanB
                                        hotkey="shift+A"
                                    >
                                        Abonar
                                    </ButtonItem>
                                }
                            />
                        </Form>
                    </Spin>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(AgregarAbonoProveedor);
